import { render, staticRenderFns } from "./ShowNameConfigDialog.vue?vue&type=template&id=510ff26d&scoped=true&"
import script from "./ShowNameConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ShowNameConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShowNameConfigDialog.vue?vue&type=style&index=0&id=510ff26d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ff26d",
  null
  
)

export default component.exports